import m from "../../geodata/es2015/algeriaHigh";
window.am4geodata_algeriaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/algeriaHigh.js
// module id = null
// module chunks = 